import { QuickIntroMessagesScreen } from '@/components/QuickIntroMessagesScreen';

export default function QuickIntroMessages() {
  return <QuickIntroMessagesScreen />;
}
